// extracted by mini-css-extract-plugin
module.exports = {"root":"CalendarWithDate_root__agG2v","date":"CalendarWithDate_date__X1pRe"};